import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import StarredContentMenuQuery, {
	type StarredContentMenuQuery$data,
	type StarredContentMenuQuery$variables,
} from './__generated__/StarredContentMenuQuery.graphql.ts';
import { starredContentMenuQueryVars } from './starredContentMenuConstants.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadStarredContentMenu(): Promise<{
	data: StarredContentMenuQuery$data | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<StarredContentMenuQuery$data, StarredContentMenuQuery$variables>({
		query: StarredContentMenuQuery,
		variables: starredContentMenuQueryVars,
		fetchPolicy: 'network-only',
	});
}
